import { LinkButton, UIHeading4, UIText1, UIText2, useDeviceType } from '@cian/ui-kit';
import classNames from 'classnames';
import * as React from 'react';

import * as styles from './EmptyChatList.css';
// @ts-expect-error TODO: исправить импорт картинок
import archiveImg from './assets/archive.png';
// @ts-expect-error TODO: исправить импорт картинок
import messagesImg from './assets/messages.png';
// @ts-expect-error TODO: исправить импорт картинок
import spamImg from './assets/spam.png';
import { EDeviceType } from '../../types/deviceType';
import { ERoute, TRoute } from '../../types/route';

type TEmptyChatListProps = {
  route: TRoute;
  withLinkButton?: boolean;
};

const Images: { [key in ERoute]: string } = {
  [ERoute.Archive]: archiveImg,
  [ERoute.Messages]: messagesImg,
  [ERoute.Spam]: spamImg,
  [ERoute.Unread]: archiveImg,
};

const HeadingTexts: { [key in ERoute]: string } = {
  [ERoute.Archive]: 'Здесь будут архивные чаты',
  [ERoute.Messages]: 'Здесь пока нет сообщений',
  [ERoute.Spam]: 'Здесь будут заблокированные чаты',
  [ERoute.Unread]: 'Здесь будут непрочитанные сообщения',
};

const DescriptionTexts: { [key in ERoute]: string | React.ReactNode } = {
  [ERoute.Archive]: 'Таких пока нет',
  [ERoute.Messages]: (
    <>
      Они появятся, как только
      <br />
      кто-нибудь напишет
    </>
  ),
  [ERoute.Spam]: 'Таких пока нет',
  [ERoute.Unread]: 'Таких пока нет',
};

export const EmptyChatList: React.VFC<TEmptyChatListProps> = ({ route, withLinkButton = true }) => {
  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;
  const showLinkButton = !isMobile && route === ERoute.Messages && withLinkButton;

  return (
    <div className={styles['container']}>
      <img src={Images[route]} width={100} height={100} alt="Тип сообщений" />
      <span
        className={classNames(styles['heading'], !isMobile && route === ERoute.Messages && styles['heading--messages'])}
      >
        <UIHeading4>{HeadingTexts[route]}</UIHeading4>
      </span>
      {isMobile ? (
        <UIText2 color="gray60_100">{DescriptionTexts[route]}</UIText2>
      ) : (
        <UIText1 color="gray60_100">{DescriptionTexts[route]}</UIText1>
      )}
      {showLinkButton && (
        <span className={styles['button']}>
          <LinkButton theme="fill_primary" href="/">
            Искать недвижимость
          </LinkButton>
        </span>
      )}
    </div>
  );
};
